// extracted by mini-css-extract-plugin
export default {"component":"styles__component--ba7Yy","close":"styles__close--vawXu"};